export const NAVIGATION_URL = '/dashboard/trending-stocks/stocks-details/';
export const FIRST_DASHBOARD_LEARN_IMAGE = '/assets/dashboardImg/learn1.png';
export const SECOND_DASHBOARD_LEARN_IMAGE = '/assets/dashboardImg/learn2.png';
export const THIRD_DASHBOARD_LEARN_IMAGE = '/assets/dashboardImg/learn3.png';
export const GREEN_ARROW_ICON = '/assets/Portfolio/greenarrowTriangle.png';
